import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ClientContactsApiAdapter } from '../adapters/ClientContactsApiAdapter';

export const useDeleteTeamContact = (teamId: number) => {
    const queryClient = useQueryClient();

    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ClientContactsApiAdapter(httpClient);
    }, []);

    const mutation = useMutation({
        mutationFn: (contactId: number) =>
            apiAdapter.deleteContact(teamId, contactId),
        onSuccess: () => {
            // Invalidar la cache de contactos para refrescar los datos
            queryClient.invalidateQueries({ queryKey: ['team-contacts', teamId] });
            // También invalidar la cache del cliente por si acaso
            queryClient.invalidateQueries({ queryKey: ['client', teamId] });
        },
    });

    return {
        deleteContact: mutation.mutate,
        deleteContactAsync: mutation.mutateAsync,
        isPending: mutation.isPending,
        isSuccess: mutation.isSuccess,
        error: mutation.error,
        reset: mutation.reset,
    };
};

